<script setup lang="ts">
import { createFAQSchema } from '~/schemas/FAQ';

const props = withDefaults(
    defineProps<{
        title: string,
        items: {
            question: string,
            answer: string
        }[],
        lgGridCols?: `lg:${ TTailwindGridCols }`,
    }>(),
    { lgGridCols: 'lg:grid-cols-2' }
);

useHead({
    script: [
        {
            type: 'application/ld+json',
            textContent: JSON.stringify(createFAQSchema(props.items))
        }
    ]
});

export type TFAQ = typeof props.items;

const cols = computed(() => +props.lgGridCols[props.lgGridCols.length - 1]!);

function getItemsByColumn(colIndex: number) {
    return props.items.filter((_, i) => i % cols.value === colIndex);
}
</script>

<template>
    <SectionsBase id="FAQ" class="container">
        <ChipsDivider>سوالات متداول</ChipsDivider>
        <div class="w-full flex flex-col items-center gap-5 mb-10">
            <h2>{{ props.title }}</h2>
        </div>
        <AccordionGroup>
            <div 
                class="grid grid-cols-1 gap-x-6 gap-y-2 lg:gap-y-0"
                :class="props.lgGridCols"
            >
                <div
                    v-for="_, index in cols"
                    :key="index"
                    class="w-full flex flex-col gap-2"
                >
                    <SectionsFAQItem 
                        v-for="item in getItemsByColumn(index)"
                        :key="item.question"
                        :item="item"
                    />
                </div>
            </div>
        </AccordionGroup>
    </SectionsBase>
</template>